import Splide from '@splidejs/splide';
import dJSON from 'dirty-json';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.services'; // Name of the folder
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup
      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide services-slide nRel">
            <div class="services-slide__img">
              <img src="${item.image}" alt="" />
              <div class="hover">
                <img src="${item.icon}" alt="" width="82" height="82"/>
              </div>
            </div>
            <div class="services-slide__content">
              <h2>${item.title}</h2>
              <p>${item.description}</p>
              <p><strong>Learn More</strong></p>
            </div>
            <a href="${item.link}" class="nLinkArea"></a>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

//   const slider = document.querySelector('.services .splide');
//   if (!slider) return;

//   new Splide(slider, {
//     type: 'slider',
//     perPage: 4,
//     perMove: 1,
//     gap: 15,
//     pagination: false,
//     arrows: false,
//     breakpoints: {
//       1200: {
//         perPage: 3,
//         pagination: true,
//       },
//       991: {
//         perPage: 2,
//       },
//       600: {
//         perPage: 1,
//       },
//     },
//   }).mount();
// })();

/**
 * Initializing the services splide slider
 */
(() => {
  document.querySelectorAll('.services .splide').forEach((item) => {
    const slider = new Splide(item, {
      type: 'slider',
      perPage: 4,
      perMove: 1,
      gap: 15,
      pagination: false,
      arrows: true,
      breakpoints: {
        1366: {
          arrows: false,
          pagination: true,
        },
        1200: {
          perPage: 3,
        },
        991: {
          perPage: 2,
        },
        600: {
          perPage: 1,
        },
      },
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
